import React from 'react';
import './info.css';
import parse from "html-react-parser";

const Info = (props) => {
  const { titulo, texto, expanded, onClick } = props;

  return (
    <div className={`psico__info ${expanded ? 'active' : ''}`} onClick={onClick}>
      <div className="psico__info-content">
        <div className="psico__info-content__title">
          <h3>{titulo}</h3>
        </div>
        <div className="psico__info-content__text">
          <p>{parse(texto)}</p>
        </div>
      </div>
    </div>
  );
};

export default Info;
